import { useQuery } from 'react-query';
import { getPublicProfile } from 'resources/user/user.api';
import { getAvatarUrl } from 'services/storage.service';

const getPublicProfileAndAttachAvatar = async (userId) => {
  const user = await getPublicProfile(userId);

  if (user?.avatar_url) {
    const avatarUrl = await getAvatarUrl(user.avatar_url);
    user.avatar_url = avatarUrl;
  }

  return user;
}

export default function useGetPublicProfile(userId) {
  return useQuery(
    ['users.getPublicProfile', userId],
    () => getPublicProfileAndAttachAvatar(userId)
  );
}
